<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModal">
      <div class="uk-modal-header">
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 6" data-uk-tooltip="Закрыть" style="cursor: pointer;" @click="closeModal"><md-icon>close</md-icon></div>
        <div class="uk-modal-title">
          Расписание ретушеров
        </div>
      </div>
      <div class="uk-modal-body">
        <div class="uk-margin"><b>all</b> - <b>прогнозируемое кол-во заказов на эту смену</b>, записывается в таблицу schedule_calendar_time_conrol, формула расчета:<br><br>
          1) 3 недели назад текущая смена-1<br>
          2) + 3 недели назад текущая смена+1<br>
          3) + 3 недели назад текущая смена<br>
          4) + 2 недели назад текущая смена-1<br>
          5) + 2 недели назад текущая смена+1<br>
          6) + 2 недели назад текущая смена<br>
          7) + 2*1 неделя назад текущая смена-1<br>
          8) + 2*1 неделя назад текущая смена+1<br>
          9) + 2*1 неделя назад текущая смена<br>
          10) сумму * 1.1 и / 12 и округляется до меньшего целого
        </div>

        <hr class="uk-margin">

        <div class="uk-margin"><b>use</b> - сумма продуктивности всех записанных ретушеров на смену, пересчет на загрузку/обновление страницы для админа и раз в 1 минуту для ретушера, считает на 3 недели вперед от текущей смены, значение расчитывается постяонно и не сохраняются в базу, фиксируется для предыдущих смен, расчет: попередній тиждень + наступний тиждень + текущий беремо з schedule_calendar потім позмінно рахуємо продуктивності записаних людей</div>

        <hr class="uk-margin">

        <!--голубой цвет кнопки-->
        <div class="uk-grid uk-grid-small uk-flex-middle uk-margin" data-uk-grid>
          <div>
            <div class="tm-button-schedule-table tm-button-scheduletable-blue uk-button" style="width: 150px !important;">
              <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                <div>
                  <div class="tm-button-scheduletable-cell">
                    --(--)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div> - </div>
          <div>голубой цвет кнопки, если ((<b>use</b> - <b>all</b>) &gt; 10 || (<b>use</b> &gt; <b>all</b> && <b>use</b> &gt; <b>all</b> * 1.15))</div>
        </div>
        <!--зеленый цвет кнопки-->
        <div class="uk-grid uk-grid-small uk-flex-middle uk-margin" data-uk-grid>
          <div>
            <div class="tm-button-schedule-table tm-button-scheduletable-success uk-button" style="width: 150px !important;">
              <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                <div>
                  <div class="tm-button-scheduletable-cell">
                    --(--)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div> - </div>
          <div>зеленый цвет кнопки, если <b>use</b> &gt;= <b>all</b></div>
        </div>
        <!--желтый цвет кнопки-->
        <div class="uk-grid uk-grid-small uk-flex-middle uk-margin" data-uk-grid>
          <div>
            <div class="tm-button-schedule-table tm-button-scheduletable-yellow uk-button" style="width: 150px !important;">
              <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                <div>
                  <div class="tm-button-scheduletable-cell">
                    --(--)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div> - </div>
          <div>желтый цвет кнопки, если (<b>all</b> - <b>use</b>) &lt;= 10</div>
        </div>
        <!--красный цвет кнопки-->
        <div class="uk-grid uk-grid-small uk-flex-middle uk-margin" data-uk-grid>
          <div>
            <div class="tm-button-schedule-table tm-button-scheduletable-warning uk-button" style="width: 150px !important;">
              <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                <div>
                  <div class="tm-button-scheduletable-cell">
                    --(--)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div> - </div>
          <div>красный цвет кнопки во всех остальный случаях</div>
        </div>
        <!--ожидания клиента-->
        <div class="uk-grid uk-grid-small uk-margin uk-child-width-auto" data-uk-grid>
          <div class="uk-position-relative">
            <div class="tm-button-schedule-table tm-button-scheduletable-blue uk-button" style="width: 150px !important;">
              <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                <div>
                  <div class="tm-button-scheduletable-cell">
                    --(--)
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="tm-scheduletable-indication green" data-uk-tooltip="title: Клиенты ждали 1+ минут" style="right: 39px;"></div>
              <div class="tm-scheduletable-indication yellow" data-uk-tooltip="title: Клиенты ждали 15+ минут" style="right: 29px;"></div>
              <div class="tm-scheduletable-indication orange" data-uk-tooltip="title: Клиенты ждали 30+ минут" style="right: 19px;"></div>
              <div class="tm-scheduletable-indication red" data-uk-tooltip="title: Клиенты ждали 45+ минут" style="right: 9px;"></div>
              <div class="tm-scheduletable-indication black" data-uk-tooltip="title: Клиенты ждали 60+ минут"></div>
            </div>
          </div>
          <div> - </div>
          <div class="uk-width-expand"><b>ожидание клиента на смене</b> - каждые 15 минут мейк стучится в basic_orders и собирает данные в json (дата создания заказа клиентом, номер заказа и расчет кол-во минут ожидания SQL запросом) по заказам со статусом "new" и если таких заказов более 5 берется максимальный показатель минут и отображается в таблице в правом верхнем углу, json с данными в пишется в order_delay_time</div>
        </div>

        <hr class="uk-margin">

        <!--смена (час) занят-->
        <div class="uk-margin">
          <b>shift_is_full = true</b> - смена закрыта для записи, если <b>use</b> / 1.1  &gt;= <b>all</b>, пересчет каждый час
        </div>
        <!--значение минут работы-->
        <div class="uk-margin">
          <b>getTime(day[1])</b> - расчетное значение минут работы на этой смене (значения включают простой, если на смене выполнялись заказы), расчитывается как сумма минут из waiting_time_retouchers и working_time_retouchers
        </div>
        <!--обозначения батареек-->
        <div class="uk-margin">
          <!--зеленая батарейка-->
          <div data-uk-grid class="uk-grid uk-child-width-auto tm-grid-xsmall uk-flex-middle">
            <div>
              <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center">
                <div class="batteryOuter color-green">
                  <div data-uk-grid class="uk-grid uk-child-width-1-4 uk-flex-middle">
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                  </div>
                </div>
                <div class="batteryBump"></div>
              </div>
            </div>
            <div>
              - зеленая батарейка, если значение минут работы на смене (с учетом простоя) больше 45
            </div>
          </div>
          <!--светло-зеленая батарейка-->
          <div data-uk-grid class="uk-grid uk-child-width-auto tm-grid-xsmall uk-flex-middle">
            <div>
              <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center">
                <div class="batteryOuter color-low-green">
                  <div data-uk-grid class="uk-grid uk-child-width-1-4 uk-flex-middle">
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                  </div>
                </div>
                <div class="batteryBump"></div>
              </div>
            </div>
            <div>
              - зеленая батарейка, если значение минут работы на смене (с учетом простоя) больше 29
            </div>
          </div>
          <!--желтая батарейка-->
          <div data-uk-grid class="uk-grid uk-child-width-auto tm-grid-xsmall uk-flex-middle">
            <div>
              <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center">
                <div class="batteryOuter color-yellow">
                  <div data-uk-grid class="uk-grid uk-child-width-1-4 uk-flex-middle">
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                  </div>
                </div>
                <div class="batteryBump"></div>
              </div>
            </div>
            <div>
              - зеленая батарейка, если значение минут работы на смене (с учетом простоя) больше 29
            </div>
          </div>
          <!--красная батарейка-->
          <div data-uk-grid class="uk-grid uk-child-width-auto tm-grid-xsmall uk-flex-middle">
            <div>
              <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center">
                <div class="batteryOuter border-red color-red">
                  <div data-uk-grid class="uk-grid uk-child-width-1-4 uk-flex-middle">
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                  </div>
                </div>
                <div class="batteryBump"></div>
              </div>
            </div>
            <div>
              - красная батарейка, если значение минут работы на смене (с учетом простоя) не больше 15 включительно
            </div>
          </div>
          <!--пропус-->
          <div data-uk-grid class="uk-grid uk-child-width-auto tm-grid-xsmall uk-flex-middle">
            <div>
              <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center">
                <div class="batteryOuter border-red color-red">
                  <div data-uk-grid class="uk-grid uk-child-width-1-4 uk-flex-middle">
                    <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 10px; font-size: 8px;">пропуск</div>
                  </div>
                </div>
                <div class="batteryBump"></div>
              </div>
            </div>
            <div>
              - был записан на смену, но значение минут работы на смене (с учетом простоя) = 0
            </div>
          </div>
          <!--черная батарейка-->
          <div data-uk-grid class="uk-grid uk-child-width-auto tm-grid-xsmall uk-flex-middle">
            <div>
              <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center">
                <div class="batteryOuter tm-battery-black color-red">
                  <div data-uk-grid class="uk-grid uk-child-width-1-4 uk-flex-middle">
                    <div>
                      <div class="batteryLevel"></div>
                    </div>
                  </div>
                </div>
                <div class="batteryBump"></div>
              </div>
            </div>
            <div>
              - черная батарейка, если ретушер ранее не был записан на смену, бонусы в таком случае не предусмотрены
            </div>
          </div>
        </div>
        <!--запись на смену под ретушером-->
        <div class="uk-margin">
          Ретушер может записываться на не более чем 6 смен подряд и не более 10 смен за 24 часа, не включая текущий (на 23 назад и 23 часов вперед от текущей смены)
        </div>
        <!--ячейки для записи-->
        <div class="uk-margin">
          Ретушеру доступы для записи след неделя + 3 дня не считая текущей для записи
        </div>

        <!--бонусы и штрафы-->
        <div class="uk-margin">
          При записи ретушера на будущие смены ему авансом отмечается бонус <span class="tm-scheduletable-bonus-penalty tm-bonus">+10</span><br>
          При отработке продуктивной дневной смены (<span style="color: #B2D580;font-weight: bold;">светло-зеленая</span> или <span style="color: #73AD21;font-weight: bold;">зеленая</span> батарейки) - бонус <span class="tm-scheduletable-bonus-penalty tm-bonus">+5</span><br>
          При отработке продуктивной ночной смены (<span style="color: #B2D580;font-weight: bold;">светло-зеленая</span> или <span style="color: #73AD21;font-weight: bold;">зеленая</span> батарейки) - бонус <span class="tm-scheduletable-bonus-penalty tm-bonus">+10</span><br>
          При отработке продуктивных 6 ночных смен подряд (<span style="color: #B2D580;font-weight: bold;">светло-зеленая</span> или <span style="color: #73AD21;font-weight: bold;">зеленая</span> батарейки + допускается одна <span style="color: #E8B100;font-weight: bold;">желтая</span>) - бонус <span class="tm-scheduletable-bonus-penalty tm-bonus">+25</span><br>
          При пропуске смены (<span style="color: #f00000;font-weight: bold;">красная</span> батарейка) - штраф <span class="tm-scheduletable-bonus-penalty tm-penalty">-25</span>
        </div>

        <div class="uk-margin" style="display: none">
          ?? Производительность (продуктивность) - записывается в таблицу productivity_retouchers_period каждый день в 6 утра методом retouchers:productivity-daily-check за прошлый день, расчет: $perPeriodGlobalFailureRate = round($productivityCount->orders_per_previous_period_sum / $productivityCount->orders_per_previous_period_all_sum , 2);
          <br>
          производительность - расчитывается раз в час (15 минута) на 3 недели вперед от текущей смены скриптом calculate:done-retoucher-done-proretoucher-orders, фиксируется для предыдущих смен в schedule_calendar_time_control
          <br>
          розрахнок на перед на ти три тижні вперед  на основі даних з productivity_retouchers_period(звідси тягнемо продуктивності) і schedule_calendar записуємо в schedule_calendar_time_control
          <br>
          для отображения на фронте тянем из schedule_calendar_time_control для ускорения расчетов
        </div>

        <!--производительность ретушера-->
        <div class="uk-margin">
          <b>Производительность ретушера</b> - это среднеее кол-во заказов за все ранее записанные смены, расчитывается как сумма всех заказов на записанных сменах за последние 30 дней деленная на кол-во записанных смен за последние 30 дней
        </div>
        <div class="uk-background-muted uk-padding-small">
          <div class="uk-margin-small">Текущий запрос для производительности ретушера</div>
          <code>
            SELECT t.user_id, t.orders_per_hour_per_period, t.work_shifts_per_period, t.orders_per_previous_period, t.date_to, t.date_from
            FROM productivity_retouchers_period t
            JOIN (
            SELECT user_id,MAX(created_at) AS max_created_at
            FROM productivity_retouchers_period
            GROUP BY user_id
            ) subquery ON t.created_at = subquery.max_created_at  and t.user_id = subquery.user_id
            group by t.user_id, t.orders_per_hour_per_period, t.work_shifts_per_period, t.orders_per_previous_period, t.date_to, t.date_from;
          </code>
          <div class="uk-margin-small">Правильный запрос для производительности ретушера</div>
          <code>
            SELECT t.user_id,
            t.orders_per_hour_per_period,
            t.work_shifts_per_period,
            t.orders_per_previous_period,
            t.date_to,
            t.date_from
            FROM productivity_retouchers_period t
            JOIN (
            SELECT user_id, MIN(date_to) AS min_date_to
            FROM productivity_retouchers_period
            GROUP BY user_id
            ) subquery ON t.user_id = subquery.user_id AND t.date_to = subquery.min_date_to
          </code>
          <div class="uk-margin-small">
            Запросы отдают производительность всех ретушеров без привязки к смене
          </div>
        </div>

        <!--сумма производительности ретушеров-->
        <div class="uk-margin">
          <b>Сумма производительности ретушеров, записанных на смену</b> - сумма производительности записанных на смене ретушеров, деленное на кол-во ретушеров записанных на смене (?? - точно не учавстует в сумме производительность ретушеров, которые не были записаны ??)
        </div>

        <!--простой-->
        <div class="uk-margin">
          <b>Кол-во минут простоя на всех ретушеров</b> - сумма минут простоя за текущую смену всех записанных ретушеров, данные тянутся из таблицы waiting_time_retouchers
        </div>
        <!--фактическое значение выполенных заказов-->
        <div class="uk-margin">
          <b>Фактическое значение выполенных заказов на этой смене</b> - сумма заказов, выполненных на текущей смене по всем записанным ретушерам, данное значение записывается в schedule_calendar_time_control (колонка order_done_in_shift) за прошлую смену в начале следующей, значение суммы формируется из таблицы schedule_calendar (в колонке done_orders) за соответствующую смену для всех записанных на смену ретушеров
        </div>

        <!--замочек при записи-->
        <div class="uk-margin">
          <div>
            <md-icon>lock</md-icon> - отметка закрытого замочека в последующих сменах означает, что смена для ретушера является обязетльной и отписаться самостоятельно он не сможет
          </div>
          <div>
            <md-icon>lock_open</md-icon> - отметка открытого замочека в последующих сменах означает, что сменя для решура является обязательной и отписаться от нее может только, если от текущей смены не менее 48 часов
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
  async created() {
  }
}
</script>